import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import CarBrands from './carBrands';
import CarCard from '../commonComponents/carCard';
import Pagination from '../commonComponents/pagination';

export default () => {
  const showCarCards = useSelector((state) => state.catalog.showCarCards);
  return (
    <section className="section-default">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h2 className="ui-title">
              {startup.content.OurVehiclesPart1}
              <span className="text-primary">
                {` ${startup.content.OurVehiclesPart2}`}
              </span>
            </h2>
            <ul className="list-unstyled brand-list d-flex flex-wrap justify-content-center">
              <CarBrands />
            </ul>
          </div>
        </div>
        <div className="b-goods-group row" id="car-section">
          <Suspense
            fallback={
              <p style={{ margin: '20px auto' }}>{startup.content.Loading}</p>
            }
          >
            <CarCard cardBackground="b-goods-f_dark" />
          </Suspense>
        </div>
        <nav
          aria-label="Page navigation"
          className={showCarCards ? 'pagination-nav' : 'pagination-nav-hidden'}
        >
          <ul className="pagination justify-content-center">
            <Pagination />
          </ul>
        </nav>
      </div>
    </section>
  );
};
